module.exports = __webpack_public_path__ + "static/media/m_beard_medium_round__oval_vector.95538685.svg";